var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-action-button',{attrs:{"label":"Add Watercourses","icon":"mdi-plus","color":"success","text":""},on:{"click":_vm.addWatercourses}})
}
var staticRenderFns = []

export { render, staticRenderFns }